import { render } from "./UnAuthenticatedShoppingCart.vue?vue&type=template&id=4df673c9"
import script from "./UnAuthenticatedShoppingCart.vue?vue&type=script&lang=js"
export * from "./UnAuthenticatedShoppingCart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafen2-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__